// 10 MB
const mockFileAttachment = new File(["(⌐□_□)"], "chucknorris.png", {
  type: "image/png",
});
Object.defineProperty(mockFileAttachment, "size", {
  value: 10 * 1024 * 1024,
});

const mockLongNameFileAttachment = new File(
  ["(⌐□_□)"],
  "chucknorris-is-a-scary-scary-scary-person.png",
  {
    type: "image/png",
  }
);

// 100 MB
const mockLargeFileAttachment = new File(["(⌐□_□)"], "chucknorris.png", {
  type: "image/png",
});
Object.defineProperty(mockLargeFileAttachment, "size", {
  value: 100 * 1024 * 1024,
});

const mockSecondLargeFileAttachment = new File(
  ["(⌐□_□)"],
  "also-chucknorris.png",
  {
    type: "image/png",
  }
);
Object.defineProperty(mockSecondLargeFileAttachment, "size", {
  value: 100 * 1024 * 1024,
});

export {
  mockFileAttachment,
  mockLargeFileAttachment,
  mockSecondLargeFileAttachment,
  mockLongNameFileAttachment,
};
